export const NOTIFICATION_MESSAGES = {
  error: "Authorization Failure",
  success: "Your order has successfully been processed.",
  processing: "Your order is processing!",
  order_not_found: "Order not found."
};
